import { GET_ENTREGADORES } from '../actions/types';

const entregadorReducer = (state = { lista: [] }, action) => {
	switch(action.type){
		case GET_ENTREGADORES:
			return {
				...state,
				lista: action.payload.entregadores || [],
			};
		default:
			return state;
	}
};

export default entregadorReducer;
